// extracted by mini-css-extract-plugin
export default {"selection":"MasterPlayerWorkBox_selection__oTUwP"};